export default function () {
    // Load more
    let $loadMoreTarget = jQuery('.js-load-more-target');
    let $filters = jQuery('.js-filter-holder');
    let $loadMoreLoader = jQuery('.js-load-more-loader');

    jQuery('.js-load-more').on('click', function () {
        let button = this;
		$loadMoreLoader.removeClass('uk-hidden');
        button.disabled = true;
        jQuery.post(window.location.href, $loadMoreTarget.data())
            .done(function (response) {
                $loadMoreTarget.append(response.data.content);
                jQuery(document).trigger('load-more-finished');
            })
            .always((response)=> {
                let $button = jQuery(button);
				$loadMoreLoader.addClass('uk-hidden');
                if (typeof response !== 'undefined' && response.hasOwnProperty('data') && response.data.hasOwnProperty('paged') && response.data.hasOwnProperty('max_num_pages')) {
                    $loadMoreTarget
                        .data('paged', parseInt(response.data.paged) + 1)
                        .data('max_num_pages', response.data.max_num_pages);
                    if (response.data.paged >= response.data.max_num_pages) {
                        $button.addClass('uk-hidden');
                        return;
                    }
                } else {
                    $button.addClass('uk-hidden');
                    return;
                }
                $button.removeClass('uk-hidden');
                button.disabled = false;
            })
    });

    if ($filters.length) {
        $filters.find('select').on('change', function (e) {
        	e.preventDefault();
            let $this = jQuery(this);
			applyFilter($this.prop('name'), $this.val());
        });

		$filters.find('.js-filter-tabs').on('click', 'li',function (e) {
			e.preventDefault();
			let $this = jQuery(this);
			let $filter = $this.parents('.js-filter-tabs')
			$filter.find('.uk-active').removeClass('uk-active');
			$this.toggleClass('uk-active');
			applyFilter($filter.data('name'), $this.data('value'));
		});
    }
    function applyFilter(name, value){
		let $target = jQuery('.js-load-more-target');
		let filters = $target.data('filters') || {};

		// Apply filter
		filters[name] = value;
		$target
			.data('filters', filters) // this might be removed in the future
			.data('paged', 1)
			.empty();

		setTimeout(function () {
			updateUrl(name, value);
			jQuery('.js-load-more').removeClass('uk-hidden').trigger('click');
		}, 100);
	}

    function updateUrl(name, value){
    	let newUrl = updateURLParameter(window.location.href,name, value);

		history.pushState(null, null, newUrl);
	}

	function updateURLParameter(url, param, paramVal) {
		let TheAnchor = null;
		let newAdditionalURL = "";
		let tempArray = url.split("?");
		let baseURL = tempArray[0];
		let additionalURL = tempArray[1];
		let temp = "";

		if (additionalURL) {
			let tmpAnchor = additionalURL.split("#");
			let TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];
			if (TheAnchor)
				additionalURL = TheParams;

			tempArray = additionalURL.split("&");

			for (let i = 0; i < tempArray.length; i++) {
				if (tempArray[i].split('=')[0] != param) {
					newAdditionalURL += temp + tempArray[i];
					temp = "&";
				}
			}
		}
		else {
			let tmpAnchor = baseURL.split("#");
			let TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];

			if (TheParams)
				baseURL = TheParams;
		}

		if (TheAnchor)
			paramVal += "#" + TheAnchor;

		let rows_txt = '';
		if (paramVal) {
			rows_txt = temp + "" + param + "=" + paramVal;
		}

		let params = newAdditionalURL + rows_txt;
		let newUrl = baseURL;
		if (params) {
			baseURL = baseURL.replace(/page\/(\d+)\//gi,'');
			newUrl = baseURL + "?" + newAdditionalURL + rows_txt;
		}
		return newUrl;
	}
}
